function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.is-finite.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import { showToast } from 'vant';
import 'vant/es/toast/style';
import 'vant/es/pull-refresh/style';
import 'vant/es/list/style';
import 'vant/es/empty/style';
import 'vant/es/button/style';
import 'vant/es/popup/style';
import 'vant/es/icon/style';
import 'vant/es/tabs/style';
import 'vant/es/tab/style';
import '../../qipao_bridge';
import htbg from '../../assets/htbg.png';
import htbgicon from '../../assets/htbgicon.png';
import htpangebg from '../../assets/htpangebg.png';
import shareIcon from '../../assets/share.png';
import xiangceIcon from '../../assets/xiangceicon.png';
import zichanIcon from '../../assets/zichanicon.png';
import { PostsApi } from '../../api';
import CirclePostOpenAppConfirm from '../../components/global/CirclePostOpenAppConfirm.vue';
import WechatOpenLaunchApp from '../../components/global/WechatOpenLaunchApp.vue';
import CreatorContestKefuPopup from './components/CreatorContestKefuPopup.vue';
import creatorContestActivityJoinApp from '../../mixins/creatorContestActivityJoinApp';
import wechatJsSdkMixin from '../../mixins/wechatJsSdkMixin';
import { ACTIVITY_WEBVIEW_HOST } from '../../utils/activityWebviewAppLink';
import { isWeChatBrowser } from '../../utils/isWeChatBrowser';
var DEFAULT_TAG_ID = '';
export default {
  name: 'CreatorContest',
  components: {
    CirclePostOpenAppConfirm: CirclePostOpenAppConfirm,
    WechatOpenLaunchApp: WechatOpenLaunchApp,
    CreatorContestKefuPopup: CreatorContestKefuPopup
  },
  mixins: [wechatJsSdkMixin, creatorContestActivityJoinApp],
  data: function data() {
    return {
      tagId: DEFAULT_TAG_ID,
      activeTab: 'latest',
      refreshing: false,
      htbg: htbg,
      htbgicon: htbgicon,
      htpangebg: htpangebg,
      shareIcon: shareIcon,
      xiangceIcon: xiangceIcon,
      zichanIcon: zichanIcon,
      publishSheetShow: false,
      kefuPopupShow: false,
      player: {
        show: false,
        url: ''
      },
      latest: {
        page: 1,
        size: 10,
        items: [],
        loading: false,
        finished: false,
        error: false,
        /** 防止与 van-list 写入的 loading 冲突导致 @load 内直接 return */
        _inflight: false
      },
      hot: {
        page: 1,
        size: 10,
        items: [],
        loading: false,
        finished: false,
        error: false,
        _inflight: false
      }
    };
  },
  created: function created() {
    this.tagId = this.resolveTargetId();
  },
  computed: {
    /**
     * `wx-open-launch-app` extinfo，端上按 OpenSDK messageExt 解析
     * @returns {string}
     */
    wxActivityLaunchExtinfo: function wxActivityLaunchExtinfo() {
      var activityUrl = this.getActivityH5FullUrl();
      return JSON.stringify({
        path: ACTIVITY_WEBVIEW_HOST,
        url: activityUrl,
        user_code: this.userCode || ''
      });
    },
    pageBgStyle: function pageBgStyle() {
      return {
        background: '#f6f1e8'
      };
    },
    topBgStyle: function topBgStyle() {
      return {
        backgroundImage: "url('".concat(this.htpangebg, "')"),
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top center',
        backgroundSize: '100% 100%'
      };
    },
    headerStyle: function headerStyle() {
      return {
        background: 'transparent'
      };
    },
    ctaStyle: function ctaStyle() {
      return {
        backgroundImage: "url('".concat(this.htbg, "')"),
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: '100% 100%'
      };
    },
    /**
     * 「我也要参赛」在微信外站优先走开放标签（不再回退普通按钮提示）。
     * @returns {boolean}
     */
    shouldUseWechatLaunchTagForJoin: function shouldUseWechatLaunchTagForJoin() {
      return isWeChatBrowser() && !this.isActivityInAppWebView() && !!this.wechatOpenLaunchAppId;
    },
    /**
     * 外站浏览器无原生桥，分享不可用，隐藏入口；仅 App WebView 内展示。
     * @returns {boolean}
     */
    showHeaderShareBtn: function showHeaderShareBtn() {
      var bridge = this.getBridge();
      return !!(bridge && bridge.isSupported && typeof bridge.openSharePanel === 'function');
    }
  },
  methods: {
    resolveTargetId: function resolveTargetId() {
      var _ref, _ref2, _ref3, _this$$route$query$ta, _this$$route, _this$$route$query, _this$$route2, _this$$route2$query, _this$$route3, _this$$route3$query, _this$$route4, _this$$route4$query, _this$$route5, _this$$route5$query;
      var fromRoute = (_ref = (_ref2 = (_ref3 = (_this$$route$query$ta = (_this$$route = this.$route) === null || _this$$route === void 0 ? void 0 : (_this$$route$query = _this$$route.query) === null || _this$$route$query === void 0 ? void 0 : _this$$route$query.targetid) !== null && _this$$route$query$ta !== void 0 ? _this$$route$query$ta : (_this$$route2 = this.$route) === null || _this$$route2 === void 0 ? void 0 : (_this$$route2$query = _this$$route2.query) === null || _this$$route2$query === void 0 ? void 0 : _this$$route2$query.targetId) !== null && _ref3 !== void 0 ? _ref3 : (_this$$route3 = this.$route) === null || _this$$route3 === void 0 ? void 0 : (_this$$route3$query = _this$$route3.query) === null || _this$$route3$query === void 0 ? void 0 : _this$$route3$query.tagid) !== null && _ref2 !== void 0 ? _ref2 : (_this$$route4 = this.$route) === null || _this$$route4 === void 0 ? void 0 : (_this$$route4$query = _this$$route4.query) === null || _this$$route4$query === void 0 ? void 0 : _this$$route4$query.tagId) !== null && _ref !== void 0 ? _ref : (_this$$route5 = this.$route) === null || _this$$route5 === void 0 ? void 0 : (_this$$route5$query = _this$$route5.query) === null || _this$$route5$query === void 0 ? void 0 : _this$$route5$query.tag_id;
      var raw = this.normalizeTargetId(fromRoute);
      if (raw !== '') return raw;
      if (typeof window === 'undefined' || typeof location === 'undefined') return '';
      var fromSearch = this.normalizeTargetId(new URLSearchParams(location.search || '').get('targetid'));
      if (fromSearch !== '') return fromSearch;
      var hash = String(location.hash || '');
      var qIndex = hash.indexOf('?');
      if (qIndex < 0) return '';
      var query = hash.slice(qIndex + 1);
      return this.normalizeTargetId(new URLSearchParams(query).get('targetid'));
    },
    normalizeTargetId: function normalizeTargetId(value) {
      var raw = String(value !== null && value !== void 0 ? value : '').trim();
      if (raw === '') return '';
      var n = Number(raw);
      return Number.isFinite(n) ? n : raw;
    },
    sanitizeUrl: function sanitizeUrl(value) {
      var s = String(value || '').replace(/`/g, '').trim().replace(/^['"]+|['"]+$/g, '');
      return s;
    },
    getCoverUrl: function getCoverUrl(item) {
      return this.sanitizeUrl((item === null || item === void 0 ? void 0 : item.cover_url) || (item === null || item === void 0 ? void 0 : item.coverUrl) || '');
    },
    getVideoUrl: function getVideoUrl(item) {
      return this.sanitizeUrl((item === null || item === void 0 ? void 0 : item.new_video_url) || (item === null || item === void 0 ? void 0 : item.video_url) || (item === null || item === void 0 ? void 0 : item.videoUrl) || '');
    },
    getAvatarUrl: function getAvatarUrl(item) {
      var _item$user_info;
      return this.sanitizeUrl((item === null || item === void 0 ? void 0 : (_item$user_info = item.user_info) === null || _item$user_info === void 0 ? void 0 : _item$user_info.user_head_url) || '');
    },
    getUserInitial: function getUserInitial(item) {
      var _item$user_info2;
      var name = String((item === null || item === void 0 ? void 0 : (_item$user_info2 = item.user_info) === null || _item$user_info2 === void 0 ? void 0 : _item$user_info2.user_name) || '').trim();
      return name ? name.slice(0, 1) : 'U';
    },
    getTabState: function getTabState(tab) {
      return tab === 'latest' ? this.latest : this.hot;
    },
    /**
     * 解析活动标签视频列表接口的分页结构（兼容数组或 { items, total_count, has_more }）
     * @param {unknown} raw
     * @returns {{ items: any[], totalCount: number, hasMore: boolean | null }}
     */
    normalizeActivityTagListPayload: function normalizeActivityTagListPayload(raw) {
      var _ref4, _o$total_count, _o$has_more;
      if (raw == null) {
        return {
          items: [],
          totalCount: 0,
          hasMore: null
        };
      }
      if (Array.isArray(raw)) {
        return {
          items: raw,
          totalCount: raw.length,
          hasMore: null
        };
      }
      if (_typeof(raw) !== 'object') {
        return {
          items: [],
          totalCount: 0,
          hasMore: null
        };
      }
      var o = /** @type {Record<string, unknown>} */raw;
      var items = Array.isArray(o.items) ? o.items : [];
      var totalCount = Number((_ref4 = (_o$total_count = o.total_count) !== null && _o$total_count !== void 0 ? _o$total_count : o.totalCount) !== null && _ref4 !== void 0 ? _ref4 : 0) || 0;
      var hm = (_o$has_more = o.has_more) !== null && _o$has_more !== void 0 ? _o$has_more : o.hasMore;
      var hasMore = typeof hm === 'boolean' ? hm : null;
      return {
        items: items,
        totalCount: totalCount,
        hasMore: hasMore
      };
    },
    ensureFirstLoad: function ensureFirstLoad(tab) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var state;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              state = _this.getTabState(tab);
              if (!(state.items.length > 0 || state._inflight)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.n = 2;
              return _this.fetchListFor(tab, {
                reset: true
              });
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    onTabChange: function onTabChange(name) {
      this.ensureFirstLoad(name);
    },
    onLoadLatest: function onLoadLatest() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.fetchListFor('latest', {
                reset: false
              });
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    onLoadHot: function onLoadHot() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this3.fetchListFor('hot', {
                reset: false
              });
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    onRefresh: function onRefresh() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _this4.refreshing = true;
              _context4.p = 1;
              _context4.n = 2;
              return _this4.fetchListFor(_this4.activeTab, {
                reset: true
              });
            case 2:
              _context4.p = 2;
              _this4.refreshing = false;
              return _context4.f(2);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, null, [[1,, 2, 3]]);
      }))();
    },
    onRetry: function onRetry() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return _this5.fetchListFor(_this5.activeTab, {
                reset: true
              });
            case 1:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    fetchListFor: function fetchListFor(tab) {
      var _arguments = arguments,
        _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var _ref5, reset, state, _res$data, _res$data2, _res$data3, _res$data4, isLatest, res, list, _this6$normalizeActiv, chunk, totalCount, hasMore, _t, _t2;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _ref5 = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {}, reset = _ref5.reset;
              state = _this6.getTabState(tab); // 注意：van-list 触发 @load 时会先把 v-model:loading 设为 true，不能用 loading 作为「是否可请求」门禁
              if (!state._inflight) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2);
            case 1:
              if (!(!reset && state.finished)) {
                _context6.n = 2;
                break;
              }
              return _context6.a(2);
            case 2:
              if (reset) {
                state.page = 1;
                state.items = [];
                state.finished = false;
                state.error = false;
              }
              state._inflight = true;
              state.loading = true;
              state.error = false;
              _context6.p = 3;
              isLatest = tab === 'latest';
              if (!isLatest) {
                _context6.n = 5;
                break;
              }
              _context6.n = 4;
              return PostsApi.activityTagVideoLatest({
                tagId: _this6.tagId,
                page: state.page,
                size: state.size
              });
            case 4:
              _t = _context6.v;
              _context6.n = 7;
              break;
            case 5:
              _context6.n = 6;
              return PostsApi.activityTagVideoHot({
                tagId: _this6.tagId,
                page: state.page,
                size: state.size
              });
            case 6:
              _t = _context6.v;
            case 7:
              res = _t;
              list = (isLatest ? res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.latest_post_list : res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.hot_post_list) || (isLatest ? res === null || res === void 0 ? void 0 : res.latest_post_list : res === null || res === void 0 ? void 0 : res.hot_post_list) || (isLatest ? res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.latestPostList : res === null || res === void 0 ? void 0 : (_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.hotPostList) || {};
              _this6$normalizeActiv = _this6.normalizeActivityTagListPayload(list), chunk = _this6$normalizeActiv.items, totalCount = _this6$normalizeActiv.totalCount, hasMore = _this6$normalizeActiv.hasMore;
              state.items = state.items.concat(chunk);
              state.page += 1;
              if (hasMore === false) {
                state.finished = true;
              } else if (hasMore === true) {
                state.finished = false;
              } else if (chunk.length === 0) {
                state.finished = true;
              } else if (chunk.length < state.size) {
                state.finished = true;
              } else if (totalCount > 0 && state.items.length >= totalCount) {
                state.finished = true;
              } else {
                state.finished = false;
              }
              _context6.n = 9;
              break;
            case 8:
              _context6.p = 8;
              _t2 = _context6.v;
              state.error = true;
              showToast((_t2 === null || _t2 === void 0 ? void 0 : _t2.message) || '加载失败');
            case 9:
              _context6.p = 9;
              state.loading = false;
              state._inflight = false;
              return _context6.f(9);
            case 10:
              return _context6.a(2);
          }
        }, _callee6, null, [[3, 8, 9, 10]]);
      }))();
    },
    getBridge: function getBridge() {
      if (typeof window === 'undefined') return null;
      return window.QipaoBridge || null;
    },
    onClickPublishFromAssets: function onClickPublishFromAssets() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var bridge, _t3;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              bridge = _this7.getBridge();
              if (!(!bridge || typeof bridge.publishFromAssets !== 'function')) {
                _context7.n = 1;
                break;
              }
              showToast('当前环境暂不支持该能力');
              return _context7.a(2, false);
            case 1:
              _context7.p = 1;
              _context7.n = 2;
              return bridge.publishFromAssets();
            case 2:
              return _context7.a(2, true);
            case 3:
              _context7.p = 3;
              _t3 = _context7.v;
              showToast((_t3 === null || _t3 === void 0 ? void 0 : _t3.message) || '调用失败');
              return _context7.a(2, false);
          }
        }, _callee7, null, [[1, 3]]);
      }))();
    },
    onClickPublishFromAlbum: function onClickPublishFromAlbum() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var bridge, _t4;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              bridge = _this8.getBridge();
              if (!(!bridge || typeof bridge.publishFromAlbum !== 'function')) {
                _context8.n = 1;
                break;
              }
              showToast('当前环境暂不支持该能力');
              return _context8.a(2, false);
            case 1:
              _context8.p = 1;
              _context8.n = 2;
              return bridge.publishFromAlbum();
            case 2:
              return _context8.a(2, true);
            case 3:
              _context8.p = 3;
              _t4 = _context8.v;
              showToast((_t4 === null || _t4 === void 0 ? void 0 : _t4.message) || '调用失败');
              return _context8.a(2, false);
          }
        }, _callee8, null, [[1, 3]]);
      }))();
    },
    onClickShare: function onClickShare() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var bridge, _t5;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              bridge = _this9.getBridge();
              if (!(!bridge || !bridge.isSupported || typeof bridge.openSharePanel !== 'function')) {
                _context9.n = 1;
                break;
              }
              showToast('请到APP里进行操作');
              return _context9.a(2, false);
            case 1:
              _context9.p = 1;
              _context9.n = 2;
              return bridge.openSharePanel({
                title: '创作者大赛',
                content: '快来参加',
                url: typeof location !== 'undefined' ? location.href : ''
              });
            case 2:
              return _context9.a(2, true);
            case 3:
              _context9.p = 3;
              _t5 = _context9.v;
              showToast((_t5 === null || _t5 === void 0 ? void 0 : _t5.message) || '分享失败');
              return _context9.a(2, false);
          }
        }, _callee9, null, [[1, 3]]);
      }))();
    },
    onRulesClick: function onRulesClick() {
      if (this.$router) {
        this.$router.push({
          name: 'creatorContestRules'
        });
        return;
      }
      window.location.href = "".concat(location.origin, "/#/creator-contest/rules");
    },
    /**
     * 打开客服联系弹窗（二维码 + 邮箱）
     * @returns {void}
     */
    onKefuClick: function onKefuClick() {
      this.kefuPopupShow = true;
    },
    /**
     * App 内嵌：沿用原底部弹层（资产/相册发表）；外站：二次确认后拉 App activity-webview
     */
    onJoinClick: function onJoinClick() {
      if (this.shouldUseWechatLaunchTagForJoin) {
        return;
      }
      if (this.isActivityInAppWebView()) {
        this.publishSheetShow = true;
        return;
      }
      this.showAppLeaveConfirm = true;
    },
    onChoosePublish: function onChoosePublish(type) {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var isAssets, ok, _t6;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              _this0.publishSheetShow = false;
              isAssets = type === 'assets';
              if (!isAssets) {
                _context0.n = 2;
                break;
              }
              _context0.n = 1;
              return _this0.onClickPublishFromAssets();
            case 1:
              _t6 = _context0.v;
              _context0.n = 4;
              break;
            case 2:
              _context0.n = 3;
              return _this0.onClickPublishFromAlbum();
            case 3:
              _t6 = _context0.v;
            case 4:
              ok = _t6;
              if (!ok) {
                _context0.n = 5;
                break;
              }
              return _context0.a(2);
            case 5:
              return _context0.a(2);
          }
        }, _callee0);
      }))();
    },
    onPlay: function onPlay(item) {
      var postId = (item === null || item === void 0 ? void 0 : item.post_id) || (item === null || item === void 0 ? void 0 : item.postId) || '';
      var bridge = this.getBridge();
      if (bridge && typeof bridge.openVideoDetail === 'function' && postId) {
        bridge.openVideoDetail({
          postId: String(postId)
        });
        return;
      }
      var url = this.getVideoUrl(item);
      if (!url) {
        showToast('暂无视频');
        return;
      }
      this.player.url = url;
      this.player.show = true;
    },
    closePlayer: function closePlayer() {
      var el = this.$refs.videoEl;
      if (el && typeof el.pause === 'function') {
        el.pause();
      }
      this.player.show = false;
      this.player.url = '';
    }
  },
  mounted: function mounted() {
    var _this1 = this;
    this.resolveUserCode();
    window.onClickPublishFromAssets = function () {
      return _this1.onClickPublishFromAssets();
    };
    window.onClickPublishFromAlbum = function () {
      return _this1.onClickPublishFromAlbum();
    };
    window.onClickShare = function () {
      return _this1.onClickShare();
    };
    this.ensureFirstLoad(this.activeTab);
  },
  beforeUnmount: function beforeUnmount() {
    if (window.onClickPublishFromAssets) delete window.onClickPublishFromAssets;
    if (window.onClickPublishFromAlbum) delete window.onClickPublishFromAlbum;
    if (window.onClickShare) delete window.onClickShare;
  }
};